<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:28:29
 * Updated upstream
-->
<template>
  <a-config-provider :locale="zh_CN">
    <div
      id="webpatientApp"
      :class="SCREEN.mobile ? 'm-screen-mobile' : 'm-screen-pc'"
    >
      <router-view v-if="reload"></router-view></div
  ></a-config-provider>
</template>
<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { getScreenSize } from '@/utils/index'
import { hospitalMapByDomain } from '@/utils/hospitalConfig'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { message} from 'ant-design-vue'
import 'moment/locale/zh-cn'
import '@/styles/index.less'
import {rewriteStorage,setConfirmTop} from "@/utils"
moment.locale('zh-cn')
export default {
  data() {
    return {
      zh_CN,
      reload: false,
      theResizeObserver: null,
      timer: null,
    }
  },
  computed: mapGetters({
    SCREEN: 'getScreen',
    HOSPITAL: 'getHospital',
  }),
  watch: {
  },
  created() {
    const path = window.location.pathname;
    if(path=="/html/webpatient/personalCenter/hospitalEnroll"||path=="/html/webpatient/personalCenter/hospitalSignin"){
      this.reload = true
    }
    this.$store.dispatch('setScreen', getScreenSize())
    // 本地开发使用 地址后加参数?hospital=www.hfboehospital.com
    const search =
      window.location.search.indexOf('?hospital=') > -1 &&
      window.location.search.replace('?hospital=', '')
    console.log('search', search)
    if (search) {
      const domain = search || 'hfhospital.boe.com'
      this.$store.dispatch('setHospital', hospitalMapByDomain[domain])
      rewriteStorage(hospitalMapByDomain[domain].code)
      localStorage.setItem('HospitalCode', hospitalMapByDomain[domain].code)
      this.initUserInfo()
    } else {
      // --------------------test 本地开发--------------------------
      // const domain = search || 'hfhospital.boe.com'
      const domain = search || 'cdhospital.boe.com'
      // const domain = search || 'szhospital.boe.com'
      this.$store.dispatch('setHospital', hospitalMapByDomain[domain])
      rewriteStorage(hospitalMapByDomain[domain].code)
      localStorage.setItem('HospitalCode', hospitalMapByDomain[domain].code)
      this.initUserInfo()
      // --------------------test 本地开发--------------------------
    }
  },
  mounted() {
   
    // 监听父系统传来的域名信息
    window.addEventListener('message', this.getIframeMsg)
    // 监听页面变化
    window.addEventListener('resize', this.resizeHandle, false)
    this.appListener()
   
  },
  methods: {
    // 初始化用户信息
    initUserInfo() {
      debugger
      this.reload=true;
      const ut = localStorage.getItem('ut')
      const userId = localStorage.getItem('userId')
      const phone = localStorage.getItem('phone')
      window.parent.postMessage(
        {
          type: 'setUserInfo',
          userInfo: {
            userId,
            phone,
            ut,
          },
        },
        '*'
      )
    },
    // 接收父系统传来信息
    getIframeMsg(event) {
      console.log('getIframeMsg:', event.data)
      let domain = event.data.domain
      // --------------------test--------------------------
      // domain = 'www.hfboehospital.com'
      // domain = 'www.cdboehospital.com'
      // domain  = "www.szboehospital.com";
      // --------------------test--------------------------
      const type = event.data.type
      // 初始化网站信息
      if (type == 'initDomain') {
        if (domain) {
          document.body.style.overflow = 'hidden'
          this.$store.dispatch('setHospital', hospitalMapByDomain[domain])
          rewriteStorage(hospitalMapByDomain[domain].code)
          localStorage.setItem('HospitalCode', hospitalMapByDomain[domain].code)
          this.initUserInfo()
        }
        // 退出登录
      } else if (type == 'logout') {
        localStorage.clear()
        this.$router.push('/personalCenter/login')
        // 官网头部等组件跳转就诊系统页面
      } else if (type == 'changeUrl') {
        this.$router.push(event.data.url)
      } else if (type == 'getDocument') {
        const top = event.data.top==0?100:(event.data.top+100)
        message.config({
          top: top + 'px',
        })
        setConfirmTop(top)
      }
    },
    resizeHandle() {
      this.$store.dispatch('setScreen', getScreenSize())
    },
    // 监听app高度变化,给父级iframe设置高度
    appListener() {
      const app = document.getElementById('webpatientApp')
      this.theResizeObserver = new ResizeObserver((entries) => {
        const height = entries[0].target.clientHeight
        window.parent.postMessage(
          {
            type: 'setIframeHeight',
            appHeight: height,
          },
          '*'
        )
      })
      this.theResizeObserver.observe(app)
    },
  },

  beforeDestroy() {
    window.removeEventListener('message', this.getIframeMsg, false)
    window.removeEventListener('resize', this.resizeHandle, false)
    this.theResizeObserver.unobserve(document.getElementById('webpatientApp'))
    this.theResizeObserver = null
  },
}
</script>
<style lang="less" scoped>
#webpatientApp {
  background: #fff;
  &.m-screen-mobile {
    padding-bottom: 1rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}
</style>
